import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import api from "../../api";

export default function StudentStudyContent() {
  const { id } = useParams();
  const nav = useNavigate();

  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);

  /* ================= LOAD CONTENT ================= */
  useEffect(() => {
    api
      .get(`/study/content/${id}`)
      .then((res) => {
        if (res.data.locked) {
          alert("🔒 This content is locked for your subscription");
          nav("/student/study");
          return;
        }
        setContent(res.data);
      })
      .catch((err) => {
        console.error(err);
        alert("❌ Unable to load content");
        nav("/student/study");
      })
      .finally(() => setLoading(false));
  }, [id, nav]);

  if (loading) {
    return (
      <div style={loadingStyle}>
        ⏳ Loading content...
      </div>
    );
  }

  if (!content) return null;

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}>
        <div style={cardStyle}>
          {/* ================= HEADER ================= */}
          <div style={headerStyle}>
            <img
              src="/logo.png"
              alt="EduAt10"
              style={logoStyle}
            />

            <button
              onClick={() => nav("/student/study")}
              style={backBtnStyle}
            >
              ← Back to Study
            </button>
          </div>

          {/* ================= CONTENT ================= */}
          <h2 style={{ marginTop: 10 }}>📖 {content.title}</h2>
          {content.description && (
            <p style={{ color: "#475569", marginTop: 6 }}>
              {content.description}
            </p>
          )}

          {/* PDF */}
          {content.file_type === "pdf" && (
            <iframe
              src={content.file_url}
              title="PDF Viewer"
              width="100%"
              height="600"
              style={frameStyle}
            />
          )}

          {/* VIDEO */}
          {content.file_type === "video" && (
            <video
              controls
              width="100%"
              style={{ marginTop: 20, borderRadius: 8 }}
            >
              <source src={content.file_url} />
              Your browser does not support video playback.
            </video>
          )}

          {/* TEXT */}
          <style>
            {`
              .study-content table {
                width: 100%;
                border-collapse: collapse;
                margin: 15px 0;
              }

              .study-content th,
              .study-content td {
                border: 1px solid #cbd5e1;
                padding: 8px 10px;
                text-align: left;
              }

              .study-content th {
                background: #e2e8f0;
                font-weight: 600;
              }
            `}
            </style>
          {content.file_type === "text" && (
            <div
              className="study-content"
              style={textBoxStyle}
              dangerouslySetInnerHTML={{ __html: content.content_text }}
            />
          )}
        </div>
      </div>
    </div>
  );
}

/* ================= STYLES ================= */

const pageStyle = {
  minHeight: "100vh",
  backgroundImage: "url('/eduat10-bg.png')",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
};

const overlayStyle = {
  minHeight: "100vh",
  backgroundColor: "rgba(0,0,0,0.25)",
  padding: 20,
};

const cardStyle = {
  background: "rgba(255,255,255,0.95)",
  maxWidth: 1100,
  margin: "auto",
  padding: 24,
  borderRadius: 16,
};

const headerStyle = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",
  gap: 12,
};

const logoStyle = {
  width: 120,
};

const backBtnStyle = {
  padding: "10px 16px",
  background: "#e2e8f0",
  border: "none",
  borderRadius: 8,
  cursor: "pointer",
  fontWeight: 600,
};

const frameStyle = {
  border: "1px solid #cbd5e1",
  marginTop: 20,
  borderRadius: 8,
};

const textBoxStyle = {
  marginTop: 20,
  padding: 20,
  background: "#f9fafb",
  borderRadius: 8,
  lineHeight: 1.6,
  overflowX: "auto"
};

const loadingStyle = {
  padding: 30,
  fontSize: 18,
};
